import { IWorkItem } from '@models/works';

const chunkArray = (array: Array<IWorkItem>, n: number): IWorkItem[][] => {
  if (n <= 0) return []; // если n меньше или равно 0, вернуть пустой массив
  let result = [];

  for (let i = 0; i < array?.length; i += n) {
    result.push(array?.slice(i, i + n));
  }

  return result;
};
export const calculateColumnCount = (newWidth: number, array: Array<IWorkItem>) => {
  const width = newWidth ?? 2000;
  let count;
  if (width < 1060) {
    count = 2;
  } else if (width < 1400) {
    count = 3;
  } else {
    count = 4;
  }

  return chunkArray(array, count);
};
